import { SearchDriverOptions } from '@elastic/search-ui';
import ElasticSearchAPIConnector from '@elastic/search-ui-elasticsearch-connector';
import { elasticPrimaryConfig } from '@scripts/frontend/elastic/elastic-client';

const elasticConnector = (jobId: string) => new ElasticSearchAPIConnector({
  ...elasticPrimaryConfig,
  interceptSearchRequest: async (
    { requestBody },
    next,
  ) => {
    requestBody.query = {
      bool: {
        must: [{
          more_like_this: {
            fields: ['job_title', 'job_description'],
            like: [{
              _index: 'jobs-north-america',
              _id: jobId,
            }],
            min_term_freq: 1,
            max_doc_freq: 20,
            max_query_terms: 10,
          },
        }],
        must_not: [{ // Exclude the current job from results
          term: {
            _id: jobId,
          },
        }],
      },
    };
    return next(requestBody);
  },
});

export const relatedJobsConfig = (numberToShow: string, jobId: string): SearchDriverOptions => ({
  alwaysSearchOnInitialLoad: true,
  trackUrlState: false,
  initialState: {
    resultsPerPage: parseInt(numberToShow, 10),
  },
  searchQuery: {
    result_fields: {
      job_title: {
        raw: {},
      },
      job_description: {
        snippet: {},
      },
      location: {
        raw: {},
      },
      salary: {
        raw: {},
      },
      job_id: {
        raw: {},
      },
      posted_date: {
        raw: {},
      },
      offsite_preference_name: {
        raw: {},
      },
      friendly_salary: {
        raw: {},
      },
    },
  },
  apiConnector: elasticConnector(jobId),
});
